export const aboutText = `We scan your entire discography across Spotify, Apple Music and more to find missing tracks, metadata errors, distribution gaps, and countries where your music isn't available.

Our smart analysis reveals why some songs underperform — and how to fix it.

From broken links to missing lyrics or bad audio quality, we show you what's costing you streams and royalties — and how to earn more without releasing new music.

Whether you're an independent artist or managing hundreds of songs, Song Audit gives you the clarity you need to unlock your catalog's full earning potential.`; 